// Column configuration for Model Reviewer/Preparer Dashboard

const col = (id: string, label: string, isSortable = true, align = 'left' as const, disablePadding = false) => ({
  id,
  label,
  isSortable,
  align,
  disablePadding,
});

export const modelsColumns = [
  col('company_name', 'Company Name'),
  col('valuation_status', 'Valuation Status'),
  col('model_status', 'Model Status'),
  col('notes', 'Notes'),
  col('model_reviewer', 'Reviewer'),
  col('model_preparer', 'Preparer'),
  col('valuation_lead', 'Valuation Lead'),
  col('valuation_date', 'Valuation Date'),
];
